import { ErrorMessage } from "formik";
import { MdErrorOutline } from "react-icons/md";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

/* eslint-disable react/prop-types */
const InputPhone = ({
  title,
  name,
  placeholder,
  requiredField = false,
  values,
  handleChange,
  handleBlur,
}) => {
  return (
    <div className="mb-1">
      <label
        htmlFor={name}
        className="block leading-6 text-gray-500 text-sm mb-2"
      >
        {title}
        {requiredField && <span className="text-red-800 mx-1">*</span>}
      </label>
      <div className="flex gap-1 w-full">
        <PhoneInput
          country={"ug"}
          value={values[name]}
          enableSearch={true}
          countryCodeEditable={false}
          name={name}
          onChange={handleChange(name)}
          onBlur={handleBlur(name)}
          placeholder={placeholder}
        />
      </div>

      <ErrorMessage name={name}>
        {(msg) => (
          <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
            <MdErrorOutline size={16} />
            <p>{msg}</p>
          </div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default InputPhone;
